import { unzip, Unzipped } from "fflate";

import { Build, Product } from "@dashboard/products/types";

export type ZipContent = {
    product: Product;
    build: Build;
    files: { name: string; content: Blob }[];
};

const unzipAsync = (data: Uint8Array): Promise<Unzipped> =>
    new Promise((resolve, reject) => {
        unzip(data, (err, result) => (err ? reject(err) : resolve(result)));
    });

export const validateZipContent = async (file: File): Promise<ZipContent> => {
    const arrayBuffer = await file.arrayBuffer();
    const entries = await unzipAsync(new Uint8Array(arrayBuffer));

    const metadata = entries["metadata.json"];
    if (!metadata) {
        throw new Error("Metadata file not found in ZIP");
    }

    const jsonMetadataText = new TextDecoder().decode(metadata);
    const jsonMetadata: { build: Build; product: Product } = JSON.parse(jsonMetadataText);
    if (!jsonMetadata.build) {
        throw new Error("Build file not found in ZIP");
    }
    if (!jsonMetadata.product) {
        throw new Error("Product file not found in ZIP");
    }

    const files = Object.entries(entries)
        .filter(([name]) => name !== "metadata.json" && !name.endsWith("/"))
        .map(([name, content]) => ({ name, content: new Blob([content]) }));

    return { ...jsonMetadata, files };
};
